// Utilities
import { make } from 'vuex-pathify'

let image = 0

const state = {
  picture: null,
  pictures: Array.from({ length: 3 }).map(() => {
    image++

    return {
      src: require('../assets/' + `${image}.png`),
    }
  }),
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations,
}
